<template>
  <main
    v-if="film"
    class="film"
    itemscope
    :itemtype="`${film.type === 'anime' ? 'http://schema.org/Movie' : 'http://schema.org/TVSeries' }`"
  >
    <div class="breadcrumbs" itemscope itemtype="http://schema.org/BreadcrumbList">
      <div itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
        <nuxt-link to="/" itemprop="item">
          <span itemprop="name">Главная</span>
        </nuxt-link>
        <meta itemprop="position" content="0">
      </div>

      <div itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
        <i class="icon-arrow" />
        <nuxt-link :to="`/?type=${type}`" itemprop="item">
          <span itemprop="name">{{ type }}</span>
        </nuxt-link>
        <meta itemprop="position" content="2">
      </div>

      <div v-if="film.material_data.anime_genres" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
        <i class="icon-arrow" />
        <nuxt-link :to="`/?type=${type}&genre=${
          film.material_data.anime_genres ? film.material_data.anime_genres[0] : ''
        }`" itemprop="item">
          <span itemprop="name">
            {{ film.material_data.anime_genres ? film.material_data.anime_genres[0] : '' }}
          </span>
        </nuxt-link>
        <meta itemprop="position" content="3">
      </div>

      <div itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
        <i class="icon-arrow" />
        <span itemprop="name">{{ film.title }}</span>
        <meta itemprop="position" content="4">
      </div>
    </div>

    <section class="top">
      <div class="header">
        <div class="film-poster">
          <div class="poster" itemprop="thumbnail" itemscope itemtype="http://schema.org/ImageObject">
            <meta itemprop="contentUrl" :content="filmPoster(film)">
            <nuxt-img
              :src="`/static_files/uploads/posters/${film.anime_id}.webp`"
              :alt="`${film.title} / ${film.title_orig}`"
              fit="cover"
              preload
              format="webp"
              :width="isDesktop ? 300 : 210" 
              :height="isDesktop ? 450 : 315"
              quality="70"
            />
            <!-- <img
              :data-src="filmPoster(film)"
              :alt="`${film.title} / ${film.title_orig}`"
              src="/static_files/no-poster.png"
              class="lazyload"
            > -->
          </div>
          <Favs :payload="{
            film: {
              title: film.title, title_orig: film.title_orig, poster: filmPoster(film),
              sh_id: film.sh_id, kinopoisk_id: film.kinopoisk_id, id: film.sh_id || film.kinopoisk_id
            },
            button: false
          }" />
          <button @click="goTo('player')" class="watch-online">
            <i class="icon-watch" />
            <span>Смотреть онлайн</span>
          </button>
        </div>
        <div
          v-if="!isDesktop"
          class="film-rating"
          itemprop="aggregateRating"
          itemscope
          itemtype="http://schema.org/AggregateRating"
        >
          <meta itemprop="worstRating" content="1">
          <meta itemprop="bestRating" content="10">

          <meta v-if="film.material_data.shikimori_rating" :content="film.material_data.shikimori_rating" itemprop="ratingValue">
          <meta v-else-if="film.material_data.kinopoisk_rating" :content="film.material_data.kinopoisk_rating" itemprop="ratingValue">
          <meta v-else-if="film.material_data.imdb_rating" :content="film.material_data.imdb_rating" itemprop="ratingValue">

          <meta v-if="film.material_data.shikimori_votes" :content="film.material_data.shikimori_votes" itemprop="ratingCount">
          <meta v-else-if="film.material_data.kinopoisk_votes" :content="film.material_data.kinopoisk_votes" itemprop="ratingCount">
          <meta v-else-if="film.material_data.imdb_votes" :content="film.material_data.imdb_votes" itemprop="ratingCount">
          
          <div v-if="film.material_data.shikimori_rating">
            <strong>
              {{ film.material_data.shikimori_rating ? film.material_data.shikimori_rating : 'NA' }}
            </strong>
            <span>
              {{ film.material_data.shikimori_votes ? film.material_data.shikimori_votes : 'Нет' }} оценок
            </span>
          </div>
          <div v-else>
            <strong>
              {{ film.material_data.kinopoisk_rating ? film.material_data.kinopoisk_rating : 'NA' }}
            </strong>
            <span>
              {{ film.material_data.kinopoisk_votes ? film.material_data.kinopoisk_votes : 'Нет' }} оценок
            </span>
          </div>
          <div>
            <a href="#reviews">Рецензии</a>
          </div>
          <!-- <img style="margin-top: 20px;" src="https://avatars.mds.yandex.net/get-direct-picture/117537/00khXNThpX8nylkNKWHtAQ/orig" alt=""> -->
        </div>
      </div>
      <div class="film-meta" itemprop="video" itemscope>
        <link itemprop="url" :href="fullPath">
        <meta itemprop="alternativeHeadline" :content="film.title">
        <meta itemprop="dateReleased" content="2021-09-09T00:01:00">
        <meta itemprop="inLanguage" content="ru">
        <meta itemprop="isFamilyFriendly" content="true">
        
        <h1 itemprop="name">{{ film.title }}</h1>
        <div class="alt-name">
          {{ film.title_orig}}
          <span v-if="film.material_data.minimal_age">{{ film.material_data.minimal_age }}</span>
        </div>
        <div class="tagline">
          {{ film.material_data.tagline }}
        </div>

        <ul>
          <!-- <li v-if="film.quality">
            Качество:
            <strong>
              {{ film.quality }}
            </strong>
          </li> -->
          <li v-if="film.material_data.anime_studios && film.material_data.anime_studios.length">
            Студия:
            <strong>
              {{ film.material_data.anime_studios.join(', ') }}
            </strong>
          </li>
        </ul>

        <ul>
          <li v-if="film.material_data.anime_kind">
            Тип:
            <nuxt-link
              :to="`/?type=${film.material_data.anime_kind}`"
              style="text-transform:capitalize;"
            >
              {{ film.material_data.anime_kind }}
            </nuxt-link>
          </li>
          <li v-if="film.material_data.anime_genres">
            Жанр:
            <div>
              <nuxt-link
                v-for="g in film.material_data.anime_genres"
                :key="`genres-${g}`"
                :to="`/?genre=${g}`"
                style="text-transform:capitalize;"
              >
                {{ g }}
              </nuxt-link>
            </div>
          </li>
          <li v-if="film.material_data.anime_status">
            Статус:
            <strong>
              <nuxt-link :to="`/?status=${film.material_data.anime_status.toLowerCase()}`"
                :class="{
                  green: film.material_data.anime_status.toLowerCase() === 'ongoing',
                  red: film.material_data.anime_status.toLowerCase() === 'released',
                  orange: film.material_data.anime_status.toLowerCase() === 'anons',
                }"
                class="status"
              >{{
                film.material_data.anime_status.toLowerCase() === 'ongoing'
                  ? 'Онгоинг'
                  : film.material_data.anime_status.toLowerCase() === 'released'
                    ? 'Завершен'
                    : film.material_data.anime_status.toLowerCase() === 'anons'
                      ? 'Анонс'
                      : '' }}</nuxt-link>
              c {{ film.material_data.aired_at | filterShortDate }}
            </strong>
          </li>
          <li>
            Эпизодов вышло в эфир:
            <strong>
              <template v-if="film.material_data.episodes_aired && film.material_data.episodes_aired > 0">
                {{ film.material_data.episodes_aired }}
              </template>
              <template v-if="(film.material_data.episodes_aired && film.material_data.episodes_aired > 0) && film.material_data.episodes_total">
                из
              </template>
              <template v-if="film.material_data.episodes_total">
                {{ film.material_data.episodes_total }}
              </template>
            </strong>
          </li>
          <li v-if="film.material_data.duration">
            <template v-if="film.type === 'anime'">
              Продолжительность:
            </template>
            <template v-else>
              Длительность эпизода:
            </template>
            <strong>
              <template v-if="Math.floor((film.material_data.duration0) / 60)">
                {{ Math.floor((film.material_data.duration) / 60) }}ч.
              </template>
              <template v-if="Math.floor((film.material_data.duration) % 60)">
                {{ Math.floor((film.material_data.duration) % 60) }} мин.
              </template>
            </strong>
          </li>
          <li v-if="film.material_data.kinopoisk_rating">
            Рейтинг КиноПоиск:
            <strong>{{ ('' + film.material_data.kinopoisk_rating).slice(0, 3) }}</strong>
          </li>
          <li v-if="film.material_data.imdb_rating">
            Рейтинг IMDb:
            <strong>{{ ('' + film.material_data.imdb_rating).slice(0, 1) + (('' + film.material_data.imdb_rating).slice(1) || '.0') }}</strong>
          </li>
          <li v-if="film.material_data.shikimori_rating">
            Рейтинг Shikimori:
            <strong>{{ ('' + film.material_data.shikimori_rating).slice(0, 1) + (('' + film.material_data.shikimori_rating).slice(1) || '.0') }}</strong>
          </li>
          <li v-if="film.material_data.premiere_ru">
            Премьера (РФ):
            <strong>{{ film.material_data.premiere_ru | filterShortDate }}</strong>
          </li>
          <li v-if="film.material_data.premiere_world">
            Премьера (мир):
            <strong>{{ film.material_data.premiere_world | filterShortDate }}</strong>
          </li>
          <li v-if="film.material_data.rating_mpaa">
            PG:
            <strong>{{ film.material_data.rating_mpaa }}</strong>
            <sup v-if="parseInt(film.material_data.rating_mpaa)" :title="`Лицам до ${
              parseInt(film.material_data.rating_mpaa)
            } лет обязательно присутствие взрослого`">?</sup>
          </li>
          <li v-if="film.material_data.writers && film.material_data.writers.length">
            Авторы:
            <strong>{{ film.material_data.writers.join(', ') }}</strong>
          </li>
          <li v-if="film.material_data.studios && film.material_data.studios.length">
            Студия:
            <strong>{{ film.material_data.studios.join(', ') }}</strong>
          </li>
          <li v-if="film.material_data.other_titles_jp && film.material_data.other_titles_jp.length">
            Название по-японски:
            <strong>{{ film.material_data.other_titles_jp.join(', ') }}</strong>
          </li>
          <li v-if="film.material_data.anime_licensed_by && film.material_data.anime_licensed_by.length">
            Лицензировано:
            <strong>{{ film.material_data.anime_licensed_by.join(', ') }}</strong>
          </li>
          <li v-if="film.material_data.anime_license_name">
            Лицензионное название:
            <strong
              v-if="film.material_data.anime_license_name"
              itemprop="alternativeHeadline"
            >
              - {{ film.material_data.anime_license_name }}
            </strong>
          </li>
          <li v-if="film.material_data.other_titles && film.material_data.other_titles.length">
            Другие названия:
            <div>
              <div v-if="film.material_data.anime_title" itemprop="alternativeHeadline">
                <strong>- {{ film.material_data.anime_title }}</strong>
              </div>
              <div
                v-for="ot in film.material_data.other_titles"
                :key="ot"
                itemprop="alternativeHeadline"
              >
                <strong>- {{ ot }}</strong>
              </div>
            </div>
          </li>
        </ul>

        <div v-if="user" id="player" class="player">
          <div v-if="!showPlayer" @click="showPlayer = true" class="play-button"></div>
          <iframe
            v-else-if="film.link"
            ref="iframe"
            :src="film.link + '?uid=1JGDOR'"
            frameBorder="0"
            allow="autoplay *; fullscreen *"
            allowfullscreen
            id="iframe"
            class="iframe"
          />
        </div>

        <p class="description" itemprop="description">{{ film.material_data.description }}</p>
      </div>
      <div
        v-if="isDesktop"
        class="film-rating"
        itemprop="aggregateRating"
        itemscope
        itemtype="http://schema.org/AggregateRating"
      >
        <div v-if="film.material_data">
          <meta itemprop="worstRating" content="1">
          <meta itemprop="bestRating" content="10">

          <meta v-if="film.material_data.shikimori_rating" :content="film.material_data.shikimori_rating" itemprop="ratingValue">
          <meta v-else-if="film.material_data.kinopoisk_rating" :content="film.material_data.kinopoisk_rating" itemprop="ratingValue">
          <meta v-else-if="film.material_data.imdb_rating" :content="film.material_data.imdb_rating" itemprop="ratingValue">

          <meta v-if="film.material_data.shikimori_votes" :content="film.material_data.shikimori_votes" itemprop="ratingCount">
          <meta v-else-if="film.material_data.kinopoisk_votes" :content="film.material_data.kinopoisk_votes" itemprop="ratingCount">
          <meta v-else-if="film.material_data.imdb_votes" :content="film.material_data.imdb_votes" itemprop="ratingCount">
          
          <div v-if="film.material_data.shikimori_rating">
            <strong>
              {{ film.material_data.shikimori_rating ? film.material_data.shikimori_rating : 'NA' }}
            </strong>
            <span>
              {{ film.material_data.shikimori_votes ? film.material_data.shikimori_votes : 'Нет' }} оценок
            </span>
          </div>
          <div v-else>
            <strong>
              {{ film.material_data.kinopoisk_rating ? film.material_data.kinopoisk_rating : 'NA' }}
            </strong>
            <span>
              {{ film.material_data.kinopoisk_votes ? film.material_data.kinopoisk_votes : 'Нет' }} оценок
            </span>
          </div>
          <div>
            <a href="#reviews">Рецензии</a>
          </div>
        </div>

        <!-- <img style="margin-top: 20px;" src="https://avatars.mds.yandex.net/get-direct-picture/117537/00khXNThpX8nylkNKWHtAQ/orig" alt=""> -->

        <!-- <div id="yandex_rtb_R-A-1740435-1" style="padding-top:20px;"></div> -->
      </div>
    </section>

    <div id="yandex_rtb_R-A-1740435-2" style="padding:20px 0px;"></div>

    <section v-if="film.material_data && film.material_data.screenshots" id="frames">
      <h2>
        Кадры
      </h2>
      <FilmFrames v-if="showBlocks['0']" :payload="{ kpid: film.kinopoisk_id, screenshots: film.material_data.screenshots }" />
      <div v-else class="lazy-block" data-block-id="0" />
    </section>

    <section id="sap">
      <h2>
        Сиквелы и приквелы
      </h2>
      <FilmSap v-if="showBlocks['2']" :kpid="film.kinopoisk_id" :anime_id="film.anime_id" />
      <div v-else class="lazy-block" data-block-id="2" />
    </section>

    <div id="yandex_rtb_R-A-1740435-6" style="padding:20px 0px;"></div>
    
    <section id="related">
      <h2>
        Рекомендуем посмотреть
      </h2>
      <FilmRelated v-if="showBlocks['3']" :payload="{ kpid: film.kinopoisk_id, genre: relatedGenre }" />
      <div v-else class="lazy-block" data-block-id="3" />
    </section>

    <section id="reviews">
      <h2>
        Рецензии зрителей
      </h2>
      <FilmReviews v-if="showBlocks['5']" :kpid="film.kinopoisk_id" />
      <div v-else class="lazy-block" data-block-id="5" />
    </section>
  </main>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
    Favs: () => import('~/components/Favs.vue'),
    FilmSap: () => import('~/components/FilmSap.vue'),
    FilmReviews: () => import('~/components/FilmReviews.vue'),
    // FilmFacts: () => import('~/components/FilmFacts.vue'),
    FilmFrames: () => import('~/components/FilmFrames.vue'),
    // FilmTrailers: () => import('~/components/FilmTrailers.vue'),
    FilmRelated: () => import('~/components/FilmRelated.vue'),
    // Merch: () => import('~/components/Merch.vue'),
  },
  head() {
    return {
      title: `${this.film.title}${
        this.film.title_orig ? ` / ${this.film.title_orig}` : ''
      }${
        this.film.material_data.year ? ` (${this.film.material_data.year})` : ''
      }
      ${
        this.film.type ==='anime-serial'
          ? ' — смотреть онлайн все серии бесплатно на русском'
          : ' — смотреть онлайн бесплатно в хорошем HD качестве'
      } #${this.film.anime_id}`,
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: this.fullPath
        }
      ],
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: `${this.film.title}${
            this.film.title_orig ? ` ${this.film.title_orig}` : ''
          } смотреть онлайн`
        },
        {
          hid: 'description',
          name: 'description',
          content: `Смотрите аниме ${this.film.title}${
            this.film.title_orig ? ` / ${this.film.title_orig}` : ''
          }${
            this.film.material_data.year ? ` (${this.film.material_data.year})` : ''
          } [★${
            this.film.material_data.shikimori_rating
              ? this.film.material_data.shikimori_rating
              : this.film.material_data.kinopoisk_rating
                ? this.film.material_data.kinopoisk_rating
                : this.film.material_data.imdb_rating
                  ? this.film.material_data.imdb_rating
                  : 10
          }]: описание, кадры, мерчи, рецензии и отзывы. #${this.film.anime_id}`
        },
        {
          hid: 'og:type',
          property: 'og:type',
          content: `film.movie`
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.filmPoster(this.film)
        },
        {
          hid: 'og:image:type',
          property: 'og:image:type',
          content: `image/jpeg`
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: this.fullPath
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${this.film.title}${
            this.film.title_orig ? ` / ${this.film.title_orig}${
              this.film.material_data.year ? ` (${this.film.material_data.year})` : ''
            }` : ''
          }`
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: `${
            this.film.material_data.description
              ? this.film.material_data.description.slice(0, 300)
              : ''
          }`
        }
      ]
    }
  },
  filters: {
    filterShortDate(val) {
      const value = val
      const months = [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря'
      ]
      const day = new Date(value).getDate()
      const month = new Date(value).getMonth()
      const year = new Date(value).getFullYear()
      return `${day} ${months[month]} ${year}`
    },
    filterDate(val) {
      const value = val
      const months = [
        'янв',
        'фев',
        'мар',
        'апр',
        'мая',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек'
      ]
      const day =
        new Date(value).getDate() >= 10
          ? new Date(value).getDate()
          : '0' + new Date(value).getDate()
      const month = new Date(value).getMonth()
      const year = new Date(value).getFullYear()
      const hour =
        new Date(value).getHours() >= 10
          ? new Date(value).getHours()
          : '0' + new Date(value).getHours()
      const min =
        new Date(value).getMinutes() >= 10
          ? new Date(value).getMinutes()
          : '0' + new Date(value).getMinutes()
      return `${day} ${months[month]} ${year} в ${hour}:${min}`
    }
  },
  computed: {
    ...mapState(['user', 'isDesktop']),
    relatedGenre() {
      const genres = this.film.material_data.anime_genres || this.film.material_data.genres
      const rand = Math.floor(Math.random() * genres.length)
      return genres[rand]
    },
    fullPath() {
      const id = this.film.sh_id || this.film.wa_id || this.film.kinopoisk_id
      const title = this.film.title
      return 'https://animeitochka.ru/' + this.postUrl(id, title)
    }
  },
  async asyncData({ params, error, $axios }) {
    const id = params.id
      ? params.id.indexOf('-') > 0
        ? params.id.slice(0, params.id.indexOf('-'))
        : params.id
      : null
    if (!id) {
      error({ statusCode: 404, message: 'Материал не найден' })
    } else {
      const { data } = await $axios.get(`/api/film?id=${id}`)
      if (data.error || data.blocked.length) {
        return error({ statusCode: 404, message: 'Материал не найден' })
      }
      return {
        showPlayer: false,
        film: data,
        type: data.material_data
          ? data.material_data.anime_kind
            ? data.material_data.anime_kind
            : 'movie'
          : 'movie',
        // type: {
        //   name: data.type === 'anime' ? 'Фильмы' : 'Многосерийные',
        //   en: data.type
        // },
        showBlocks: {
          '0': false, '1': false, '2': false, '3': false, '4': false, '5': false, '6': false
        },
        loading: false
      }
    }
  },
  mounted() {
    window.removeEventListener('keydown', this.closeEsc)
    window.addEventListener('keydown', this.closeEsc)

    setTimeout(() => {
      window.removeEventListener('scroll', this.showBlock)
      window.addEventListener('scroll', this.showBlock)
      this.showBlock()
    }, 100)
  },
  methods: {
    // async voting(op) {
    //   if (!this.user) {
    //     this.$router.push('/signin')
    //   }
    //   if (this.film[`votes_${op}`].includes(this.user.id)) {
    //     this.$store.commit('setError', { status: 'info', msg: 'Уже оценивали' })
    //     setTimeout(() => this.$store.commit('clearError'), 2000)
    //     return
    //   }
    //   const body = {
    //     kinopoisk_id: this.film.kinopoisk_id,
    //     op
    //   }
    //   const { data } = await this.$axios.post(`/api/votes`, body)
    //   if (data.error) {
    //     this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
    //     setTimeout(() => this.$store.commit('clearError'), 2000)
    //   } else {
    //     this.film[`votes_${op}`].push(this.user.id)
    //   }
    // },
    goTo(section) {
      document.querySelector(`#${section}`).scrollIntoView()
    },
    showBlock() {
      const list = document.querySelectorAll('.lazy-block')
      const doc = document.documentElement.clientHeight
      list.forEach(block => {
        const visible = doc - block.getBoundingClientRect().top
        const blockId = block.dataset.blockId
        if (visible > -300 && !this.showBlocks[blockId]) {
          this.showBlocks[blockId] = true
        }
      })
    }
  }
}
</script>

<style src="~/assets/film.styl" lang="stylus" />
